import { render, staticRenderFns } from "./SpecialInspectsBindList.vue?vue&type=template&id=f0341744&scoped=true"
import script from "./SpecialInspectsBindList.vue?vue&type=script&lang=js"
export * from "./SpecialInspectsBindList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0341744",
  null
  
)

export default component.exports